const RootPath = window.g.baseUrl
const apis = {
  /* 数据字典 */
  getDictCategories: RootPath + 'plugin/baseData/dataDictionary/getCategories',
  getDictCategory: RootPath + 'plugin/baseData/dataDictionary/getCategoryForm',
  delDictCategory: RootPath + 'plugin/baseData/dataDictionary/delCategories',
  saveDictCategory: RootPath + 'plugin/baseData/dataDictionary/saveCategory',
  getDictionaries: RootPath + 'plugin/baseData/dataDictionary/index',
  getDictionary: RootPath + 'plugin/baseData/dataDictionary/getForm',
  delDictionaries: RootPath + 'plugin/baseData/dataDictionary/delBatches',
  saveDictionary: RootPath + 'plugin/baseData/dataDictionary/save',
  /* 物料 */
  getBaseMaterialCategories: RootPath + 'plugin/baseData/baseMaterial/getCategories',
  getBaseMaterialCategory: RootPath + 'plugin/baseData/baseMaterial/getCategoryForm',
  delBaseMaterialCategories: RootPath + 'plugin/baseData/baseMaterial/delCategories',
  saveBaseMaterialCategory: RootPath + 'plugin/baseData/baseMaterial/saveCategory',
  getBaseMaterials: RootPath + 'plugin/baseData/baseMaterial/index',
  getBaseMaterial: RootPath + 'plugin/baseData/baseMaterial/getForm',
  delBaseMaterials: RootPath + 'plugin/baseData/baseMaterial/delBatches',
  saveBaseMaterial: RootPath + 'plugin/baseData/baseMaterial/save',

  moveBaseMaterial: RootPath + 'plugin/baseData/baseMaterial/moveBaseMaterial'
}

export default apis
